import React, { useState, useMemo } from 'react';

const REGIMES = ['TRENDING_UP', 'RANGING', 'HIGH_VOLATILITY', 'TRENDING_DOWN'];

const REGIME_LABELS = {
    TRENDING_UP:    'Tendência ↑',
    RANGING:        'Lateral',
    HIGH_VOLATILITY:'Alta Volatilidade',
    TRENDING_DOWN:  'Tendência ↓',
};

/**
 * props:
 * - indexes       — full indexes array from beholder
 * - symbol        — e.g. "BTCUSDT"
 * - onAdd(conditions, indexes) — called with generated condition string and indexes string
 */
function RegimeConfluenceHelper({ indexes, symbol, onAdd }) {
    const [selectedRegime, setSelectedRegime] = useState('TRENDING_UP');
    const [selectedIntervals, setSelectedIntervals] = useState({});

    // Extract available MARKET_REGIME_* intervals for this symbol
    const availableIntervals = useMemo(() => {
        if (!indexes || !symbol) return [];
        const prefix = `MARKET_REGIME_`;
        return indexes
            .filter(ix => ix.symbol === symbol && ix.variable && ix.variable.startsWith(prefix))
            .map(ix => ix.variable.slice(prefix.length).split('.')[0])
            .filter((v, i, a) => v && a.indexOf(v) === i)
            .sort();
    }, [indexes, symbol]);

    function toggleInterval(interval) {
        setSelectedIntervals(prev => ({ ...prev, [interval]: !prev[interval] }));
    }

    function onAddClick() {
        const chosen = availableIntervals.filter(iv => selectedIntervals[iv]);
        if (!chosen.length) return;

        const conditions = chosen
            .map(iv => `MEMORY['${symbol}:MARKET_REGIME_${iv}'].regime === '${selectedRegime}'`)
            .join(' && ');

        const idxStr = chosen
            .map(iv => `${symbol}:MARKET_REGIME_${iv}`)
            .join(',');

        onAdd(conditions, idxStr);
        setSelectedIntervals({});
    }

    if (!availableIntervals.length) return null;

    const chosenCount = availableIntervals.filter(iv => selectedIntervals[iv]).length;

    return (
        <div className='card border-secondary mb-3'>
            <div className='card-header py-2 px-3 d-flex align-items-center'>
                <small className='fw-semibold me-1'>Confluência de Regime</small>
                <small className='text-muted'>— exige que múltiplos timeframes concordem</small>
            </div>
            <div className='card-body py-2 px-3'>
                <div className='row g-2 align-items-center'>
                    <div className='col-auto'>
                        <small className='text-muted'>Timeframes:</small>
                    </div>
                    {availableIntervals.map(iv => (
                        <div className='col-auto' key={iv}>
                            <div className='form-check form-check-inline mb-0'>
                                <input
                                    className='form-check-input'
                                    type='checkbox'
                                    id={`conf_${iv}`}
                                    checked={!!selectedIntervals[iv]}
                                    onChange={() => toggleInterval(iv)}
                                />
                                <label className='form-check-label small' htmlFor={`conf_${iv}`}>{iv}</label>
                            </div>
                        </div>
                    ))}
                    <div className='col-auto ms-2'>
                        <small className='text-muted'>Regime:</small>
                    </div>
                    <div className='col-auto'>
                        <select
                            className='form-select form-select-sm'
                            value={selectedRegime}
                            onChange={e => setSelectedRegime(e.target.value)}
                        >
                            {REGIMES.map(r => (
                                <option key={r} value={r}>{REGIME_LABELS[r]}</option>
                            ))}
                        </select>
                    </div>
                    <div className='col-auto'>
                        <button
                            type='button'
                            className='btn btn-sm btn-outline-secondary'
                            disabled={chosenCount < 2}
                            onClick={onAddClick}
                            title={chosenCount < 2 ? 'Selecione pelo menos 2 timeframes' : `Adicionar confluência de ${chosenCount} timeframes`}
                        >
                            + Adicionar Confluência
                        </button>
                    </div>
                </div>
                {chosenCount === 1 && (
                    <small className='text-warning d-block mt-1'>Selecione pelo menos 2 timeframes para uma confluência significativa.</small>
                )}
            </div>
        </div>
    );
}

export default RegimeConfluenceHelper;
